import { Flex, Box, Text, Stack, Link, HStack, VStack } from '@chakra-ui/react'
import { FiMail } from 'react-icons/fi'
import { FaSteam } from 'react-icons/fa'
import { Link as RouterLink } from 'react-router-dom'
import { Trans } from '@lingui/react/macro'

import { colors } from '../theme/cssVariables'

import Logo from './Header/Logo'
import SocialIcons from './Header/SocialIcons'
import PSkeleton from './Skeleton'
import MastercardIcon from './Icons/MastercardIcon'
import VisaIcon from './Icons/VisaIcon'
import PixIcon from './Icons/PixIcon'
import PaypalIcon from './Icons/PaypalIcon'
import { useAccount } from '../hooks/useAccount'
import LoginButton from './LoginButton'
import { useSelector } from 'react-redux'
import { selectAppState } from '../store/selectors'
import { useLanguagePath } from '../hooks/useI18nRoute'
import { BTCIcon, USDCIcon, USDTCoreIcon, USDTTronIcon } from './Icons/CryptoIcons'
import LogoBeta from './Header/LogoBeta'

const InfoLinks = () => {
  const getPath = useLanguagePath()

  return (
    <Flex direction="column">
      <Text fontWeight={700} mb={3} color={colors.colorB2} fontSize="16px">
        <Trans>Information</Trans>
      </Text>
      <Stack spacing={2}>
        <Link as={RouterLink} to={getPath('terms-of-service')}>
          <Trans>Terms of service</Trans>
        </Link>
        <Link as={RouterLink} to={getPath('/privacy-policy')}>
          <Trans>Privacy policy</Trans>
        </Link>
      </Stack>
    </Flex>
  )
}

const HelpLinks = () => {
  const getPath = useLanguagePath()
  return (
    <Flex direction="column">
      <Text fontWeight={700} mb={3} color={colors.colorB2} fontSize="16px">
        <Trans>Help</Trans>
      </Text>
      <Stack spacing={2}>
        <Link as={RouterLink} to={getPath('provably-fair')}>
          <Trans>Provably fair</Trans>
        </Link>
        <HStack spacing={2}>
          <EmailIcon />
          <Link href="mailto:hello@support@rush-b.gg">support@rush-b.gg</Link>
        </HStack>
      </Stack>
    </Flex>
  )
}
export const EmailIcon = () => {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="1" y="3" width="16" height="12" stroke="currentColor" />
      <path d="M1 6L9 10L17 6" stroke="currentColor" />
    </svg>
  )
}

const FooterBottom = () => (
  <Flex
    direction={{ base: 'column-reverse', sm: 'row' }}
    justify="space-between"
    align="center"
    fontWeight={600}
    color={colors.colorB4}
    fontSize={['xs', 'sm']}
    pl={[0, '155px']}
  >
    {/* 左侧版权信息 */}
    <VStack spacing={1} align={{ base: 'center', sm: 'start' }}>
      <HStack>
        <FaSteam />
        <Text>
          <Trans>Powered by Steam. Not affiliated with Valve Corp.</Trans>
        </Text>
      </HStack>
      <Text>
        <Trans>Copyright ©2025 RushB.GG </Trans>
      </Text>

      <Text>
        <Trans>
          NEON QUEST GAMES LTD
          <br />
          ONISIFOROU CENTER, 8011, Paphos, Cyprus
        </Trans>
      </Text>
    </VStack>

    {/* 右侧支付方式图标 */}
    {/* <HStack spacing={[2, 2, 4]} mb={{ base: 4, md: 0 }} flexWrap={'wrap'} justify={'center'}>
      <VisaIcon />
      <MastercardIcon />
      <PixIcon />
      <PaypalIcon />
      <BTCIcon key="btc" />,
      <USDTTronIcon key="usdt_tron" />,
      <USDTCoreIcon key="usdt_core" />,
      <USDCIcon key="usdc" />,
    </HStack> */}
  </Flex>
)

const Footer = () => {
  const { isLogin } = useAccount()
  const { isLoadedHeader } = useSelector(selectAppState)
  return (
    <PSkeleton isLoaded={isLoadedHeader} minH={'100px'}>
      <Box as="footer" pb={8} pt={24} px={{ base: 4, sm: 8 }} w={'100%'}>
        {/* 第一行 */}
        <Flex
          direction={{ base: 'column', sm: 'row' }}
          justify="space-between"
          mb={[10, 20]}
          alignItems={['center', 'flex-start']}
        >
          <Flex gap={'30px'} alignItems={'flex-start'} direction={{ base: 'column', sm: 'row' }}>
            <Flex
              gap={8}
              justify={{ base: 'center', md: 'space-between' }}
              width={['100%', 'auto']}
            >
              <HStack justify={{ base: 'center', md: 'start' }}>
                <LogoBeta />
              </HStack>
            </Flex>
            <Flex
              fontWeight={600}
              color={colors.colorB4}
              fontSize="14px"
              gap={8}
              justify={{ base: 'center', md: 'start' }}
              width={['100%', 'auto']}
            >
              <InfoLinks />
              <HelpLinks />
            </Flex>
          </Flex>
          <Flex alignItems={'center'} justifyContent={'center'} mt={[4, 0]} gap={7}>
            {/* <SocialIcons /> */}
            {!isLogin && <LoginButton />}
          </Flex>
        </Flex>

        {/* 第二行 */}
        <FooterBottom />
      </Box>
    </PSkeleton>
  )
}

export default Footer
